import React, { useState } from "react";
import { Notification, Collapsible } from 'grommet';

const BannerNotification = () => {

  //const [showNotification, setShowNotification] = useState(true);

  // All below placeholder... not currently showing a notif...
  const [showNotification, setShowNotification] = useState(false);

  return (

    <Collapsible open={showNotification}>
      <Notification
        status="normal"
        title="News flash!"    
        margin={{ top: '5px' }}
        onClose={() => setShowNotification(false)}
        actions={[
          {
            href: 'https://hpe.sharepoint.com/teams/Global_Workplace',
            label: 'More info',
          },
        ]}
        message="Welcome Global IT's IAM team to the Status Central community."
        global
      />
    </Collapsible>
   );
};

export { BannerNotification as Notification };